import { TemplateLink } from "./TemplateLink"

export default function FourLsContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        The 4Ls (Liked, Learned, Lacked, Longed For) is commonly credited to
        Mary Gorman and Ellen Gottesdiener from their facilitation work in the
        mid-2000s. It's a milestone-shaped format: the "Longed For" column in
        particular only makes sense after a long enough stretch that people
        have started daydreaming about what should exist next.
      </p>

      <h2>When to use this format</h2>
      <p>
        Save it for endings and beginnings. End of a release, end of a
        project phase, onboarding of a new team member, the last retro
        before a reorg. 4Ls rewards the kind of reflection you can't do at
        the end of a two-week sprint because you're too close to the ground.
        If you're running Retroboard's persistent polls, use them to track
        "Longed For" items across successive milestone retros; that column
        gets far more powerful when you can see what your team longed for
        six months ago and whether it exists yet.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Don't use it for a routine sprint retro. If nobody's <em>Longed
        For</em> anything, the column just makes the meeting awkward. Reach
        for{" "}
        <TemplateLink to="start-stop-continue">Start / Stop / Continue</TemplateLink>{" "}
        instead. 4Ls asks bigger questions than a sprint has answers for.
      </p>

      <h2>How to run it</h2>
      <p>
        Give people ten to fifteen minutes to write silently; this format
        needs more thinking time than the sprint-style ones. Group similar
        items in each column. Warm the room up by walking through Liked and
        Learned first, then spend the real discussion time on Lacked and
        Longed For, where the actionable stuff lives.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        Teams treat "Longed For" as a wishlist ("I wish we had unlimited
        budget"). Push them toward specific unmet needs the team could
        realistically pursue. A wish is a want without a plan; a longing is
        the shape of what should exist.
      </p>
    </>
  )
}
